import { IApplicationState } from '../../types/redux';

export function getMapApiKey(state: IApplicationState) {
  return state.common.mapApiKey;
}
